import React, { Component } from 'react';
export default class Legend extends Component {
    render() {
        var legendData = (
            <div className="esri-legend--card esri-widget esri-legend--stacked" style={{ height: '140px', minWidth: '200px' }}>
                <div className="esri-legend--card__section" style={{ height: '130px', minHeight: '100px', width: '200px', minWidth: '150px' }}>
                    <div>
                        <h3 className="esri-widget__heading esri-legend--card__carousel-title">Counters</h3>
                    </div>

                    <div className="esri-legend--card__label-container">
                        <div className="esri-legend--card__layer-row esri-legend--card__symbol-row">
                            <div className="esri-legend--card__symbol-cell">
                                <div style={{ opacity: 1 }}>
                                    <svg overflow="hidden" width="14" height="14" style={{ touchAction: 'none' }}><defs></defs>
                                        <g transform="matrix(1.00000000,0.00000000,0.00000000,1.00000000,7.00000000,7.00000000)">
                                            <circle fill="rgb(125, 146, 240)" fillOpacity=".7" stroke="rgb(255, 255, 255)" strokeOpacity="0.5058823529411764" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" cx="0" cy="0" r="6" fillRule="evenodd" strokeDasharray="none" dojogfxstrokestyle="solid">
                                            </circle>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className="esri-legend--card__image-label esri-legend--card__label-cell">Pedestrian Count</div>
                        </div>
                        <div className="esri-legend--card__layer-row esri-legend--card__symbol-row">
                            <div className="esri-legend--card__symbol-cell">
                                <div style={{ opacity: 1 }}>
                                    <svg overflow="hidden" width="14" height="14" style={{ touchAction: 'none' }}><defs></defs>
                                        <g transform="matrix(1.00000000,0.00000000,0.00000000,1.00000000,7.00000000,7.00000000)">
                                            <circle fill="rgb(222, 26, 26)" fillOpacity=".7" stroke="rgb(255, 255, 255)" strokeOpacity="0.5058823529411764" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" cx="0" cy="0" r="6" fillRule="evenodd" strokeDasharray="none" dojogfxstrokestyle="solid">
                                            </circle>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className="esri-legend--card__image-label esri-legend--card__label-cell">Bicycle Count</div>
                        </div>
                        <div className="esri-legend--card__layer-row esri-legend--card__symbol-row">
                            <div className="esri-legend--card__symbol-cell">
                                <div style={{ opacity: 1 }}>
                                    <svg overflow="hidden" width="14" height="14" style={{ touchAction: 'none' }}><defs></defs>
                                        <g transform="matrix(1.00000000,0.00000000,0.00000000,1.00000000,7.00000000,7.00000000)">
                                            <circle fill="rgb(169, 92, 144)" fillOpacity=".7" stroke="rgb(255, 255, 255)" strokeOpacity="0.5058823529411764" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" cx="0" cy="0" r="6" fillRule="evenodd" strokeDasharray="none" dojogfxstrokestyle="solid">
                                            </circle>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                            <div className="esri-legend--card__image-label esri-legend--card__label-cell">Bicycle/Pedestrian Count</div>
                        </div>
                    </div>
                </div>
            </div>
        )
        return legendData;
    }
}



// WEBPACK FOOTER //
// ./src/components/Legend.js